import { render, staticRenderFns } from "./payments.vue?vue&type=template&id=905c94e8&scoped=true"
import script from "./payments.vue?vue&type=script&lang=js"
export * from "./payments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "905c94e8",
  null
  
)

export default component.exports